import { IInspection } from "../../services/inspectionsService";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

interface IInspectionProps {
  inspection: IInspection;
  setInspection: () => void;
  assetId: string;
  userRole: 'CONSULTANT' | 'TOWER' | 'MANAGER' | 'PARTNERSHIP';
}

const Inspection = ({
  inspection,
  setInspection,
  assetId,
  userRole,
}: IInspectionProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const getBasePath = () => {
    switch (userRole) {
      case 'CONSULTANT':
        return '/dealership';
      case 'TOWER':
        return '/control-tower';
      case 'MANAGER':
        return '/fleet-manager';
      case 'PARTNERSHIP':
        return '/partnership';
    }
  }
  const handleScheduleImmediately = () => navigate(`${getBasePath()}/appointments/appointment?asset=${assetId}`);

  return (
    <div className="border rounded">
      <div className="padding-left-15 padding-right-15 padding-top-15">
        <span
          className="rioglyph rioglyph-arrow-left margin-right-15 cursor-pointer"
          aria-hidden="true"
          onClick={setInspection}
        ></span>
        <span className="text-size-16">{intl.formatMessage({ id: "intl-msg:fieldCampaigns.title" })}</span>
      </div>

      <hr />

      <div className="padding-15 schedule-fixed-box">
        <div>
          <img
            src="https://assets.disaltecnologia.com.br/catalog/cover/e1c1013faa90d70ee3142d3fe94d9557.webp"
            alt={intl.formatMessage({ id: "intl-msg:inspections.inspection.imageAlt" })}
            className="rounded width-100pct height-150"
            style={{ objectFit: "cover" }}
          />

          <div className="padding-top-15 text-bold">{intl.formatMessage({ id: "intl-msg:fieldCampaigns.fieldAction" })}</div>
          {inspection.name}

          <div className="padding-top-15 text-bold">{intl.formatMessage({ id: "intl-msg:fieldCampaigns.models" })}</div>
          {inspection.vehicle}

          <div className="padding-top-15 text-bold">{intl.formatMessage({ id: "intl-msg:fieldCampaigns.status" })}</div>
          {inspection.repairStatus}

          <div className="margin-top-50 width-100pct">
            <div className="text-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleScheduleImmediately}
              >
                <span className="text-capitalize">{intl.formatMessage({ id: "intl-msg:fieldCampaigns.scheduleNow" })}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inspection;
